import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-primary text-white" data-id="element-109">
      {/* Abstract Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-110">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-accent/10 blur-[120px]" data-id="element-111" />
        <div className="absolute bottom-[10%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-500/10 blur-[100px]" data-id="element-112" />

        {/* Grid Pattern */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-113" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-114">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-115">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-116">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-accent text-sm font-medium mb-6" data-id="element-117">
              <span className="flex h-2 w-2 rounded-full bg-accent" data-id="element-118"></span>
              Bridging Innovation across Jordan & USA
            </div>

            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-extrabold tracking-tight mb-6 leading-[1.1]" data-id="element-119">
              Transforming <br data-id="element-120" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-121">
                Businesses
              </span>{' '}
              <br data-id="element-122" />
              Through Tech.
            </h1>

            <p className="text-lg lg:text-xl text-slate-300 mb-8 leading-relaxed max-w-xl" data-id="element-123">
              We deliver enterprise-grade solutions in AI, Mobile Apps, Frontend
              Development, and Location Services.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-124">
              <a href="#contact" className="inline-flex justify-center items-center gap-2 px-8 py-4 bg-accent text-white font-semibold rounded-full hover:bg-accent-hover transition-all shadow-[0_0_20px_rgba(6,182,212,0.3)] hover:shadow-[0_0_30px_rgba(6,182,212,0.5)]" data-id="element-125">
                Get Started
                <ArrowRight className="w-5 h-5" data-id="element-126" />
              </a>
              <a href="#services" className="inline-flex justify-center items-center gap-2 px-8 py-4 bg-white/5 text-white font-semibold rounded-full hover:bg-white/10 transition-all border border-white/10" data-id="element-127">
                Our Services
                <ChevronRight className="w-5 h-5" data-id="element-128" />
              </a>
            </div>
          </motion.div>

          {/* Abstract Visual Element */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative hidden lg:block h-[600px]" data-id="element-129">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-130">
              {/* Central glowing orb */}
              <motion.div animate={{
              scale: [1, 1.05, 1],
              opacity: [0.8, 1, 0.8]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-131" />

              {/* Geometric shapes */}
              <div className="relative w-full h-full max-w-md" data-id="element-132">
                {/* Main floating card */}
                <motion.div animate={{
                y: [-10, 10, -10]
              }} transition={{
                duration: 6,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute top-1/4 left-10 w-48 h-64 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-6 flex flex-col justify-between" data-id="element-133">
                  <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center" data-id="element-134">
                    <div className="w-4 h-4 bg-accent rounded-full" data-id="element-135" />
                  </div>
                  <div className="space-y-2" data-id="element-136">
                    <div className="h-2 w-full bg-white/20 rounded" data-id="element-137" />
                    <div className="h-2 w-2/3 bg-white/20 rounded" data-id="element-138" />
                  </div>
                </motion.div>

                {/* Secondary floating card */}
                <motion.div animate={{
                y: [10, -10, 10]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1
              }} className="absolute bottom-1/4 right-10 w-56 h-48 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-6 flex flex-col justify-end" data-id="element-139">
                  <div className="space-y-3" data-id="element-140">
                    <div className="flex items-center gap-2" data-id="element-141">
                      <div className="w-8 h-8 rounded bg-blue-400/20" data-id="element-142" />
                      <div className="h-3 w-20 bg-white/20 rounded" data-id="element-143" />
                    </div>
                    <div className="h-2 w-full bg-white/20 rounded" data-id="element-144" />
                    <div className="h-2 w-4/5 bg-white/20 rounded" data-id="element-145" />
                  </div>
                </motion.div>

                {/* Connecting lines (SVG) */}
                <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
                zIndex: -1
              }} data-id="element-146">
                  <motion.path initial={{
                  pathLength: 0,
                  opacity: 0
                }} animate={{
                  pathLength: 1,
                  opacity: 0.3
                }} transition={{
                  duration: 2,
                  delay: 1
                }} d="M 150 250 Q 250 150 350 350" fill="none" stroke="#06B6D4" strokeWidth="2" strokeDasharray="4 4" data-id="element-147" />
                </svg>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}